<template>
  <div id="game-wrapper" :class="{start: bStartScreen}" @click="bStartScreen = false" @touchstart.self.prevent="bStartScreen = false">
    <img id="object" src="../src/assets/object.png" alt="" />
    <img id="title" src="../src/assets/title.jpg" alt="" />
    <div id="question">
      <h1 v-html="question.text">
      </h1>
      <ul>
        <li v-for="answer in question.answers" :key="answer.id" :data-answer-id="answer.id" @click="onAnswerClick(answer.id)" @touchstart.self.prevent="onAnswerClick(answer.id)" :class="{current: (answer.id == selectedAnswerId)}">
          <span>{{ answer.text }}</span>
        </li>
      </ul>
    </div>
    <div>
      <div :class="{popup: true, show: (answer.id == selectedAnswerId)}" v-for="answer in question.answers" :key="answer.id" @click="selectedAnswerId = 0" @touchstart.self.prevent="selectedAnswerId = 0" v-html="answer.popup"></div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Multiple-Choice',
  data () {
    return {
      bStartScreen: true,
      selectedAnswerId: 0,
      question: {
        text: '<span class="small">Saints are often patrons of a particular place, profession or thing. <br>If you pray to them, they can help and protect you.</span> <br><br><span>When can I ask St Sebastian for something?</span>',
        answers: [
          {
            id: 1,
            text: 'If you have a long car journey ahead of you and you want to arrive safely.',
            popup: '<h2>Unfortunately, I can’t help you here</h2> <p><img src="img/sebastian.jpg" >– but St Christopher can.</p>'
          },
          {
            id: 2,
            text: 'If many people are ill and want to get well.',
            popup: '<h2>Yes, that’s right!</h2> <p><img src="img/sebastian.jpg" >In the Middle Ages, when many people were ill with the plague, they used to pray to me for help.</p>'
          },
          {
            id: 3,
            text: 'If it is raining and you want the sun to shine.',
            popup: '<h2>Unfortunately, I can’t help you with this </h2> <p><img src="img/sebastian.jpg" >– but St John and St Paul can.</p>'
          }
        ]
      }
    }
  },
  methods: {
    onAnswerClick (id) {
      console.log('onAnswerClick()', id)
      this.selectedAnswerId = id
    }
  }
}
</script>
